import styles from './HeaderCellWrapper.module.scss';

import React from 'react';

export const HeaderCellWrapper: React.FC = (props) => {
  return <div className={styles.wrapper} {...props} />;
};
